import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule }  from '@angular/forms';

import { ReportsComponent } from './reports.component';

import { AngularMaterialModule } from '../angular-material.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule
  ],
  providers: [
  ],
  declarations: [
    ReportsComponent
  ],
  exports: [
    ReportsComponent
  ]
})
export class ReportsModule { }
